import { Check } from "@phosphor-icons/react";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectItemText,
  SelectTrigger,
  SelectValue,
} from "common/components/ui/Select";
import SelectButton from "common/components/ui/SelectButton";
import useWorkspaces from "common/datahooks/useWorkspaces";
import type { Workspace } from "common/types";

export default function WorkspaceSelect({
  selectedWorkspace,
  setSelectedWorkspace,
}: {
  selectedWorkspace: Workspace;
  setSelectedWorkspace: (selectedWorkspace: Workspace) => void;
}) {
  const { workspaces } = useWorkspaces();

  return (
    <Select
      value={selectedWorkspace.id}
      onValueChange={(newWorkspaceId) =>
        setSelectedWorkspace(workspaces.find(({ id }) => id === newWorkspaceId))
      }
    >
      <SelectTrigger id="workspace-select" asChild>
        <SelectButton size="lg" hasSelection={!!selectedWorkspace}>
          <SelectValue placeholder="Select a workspace" />
        </SelectButton>
      </SelectTrigger>

      <SelectContent className="z-aboveDialog">
        {workspaces
          .filter(({ role }) => role === "owner")
          .map(({ id, name }) => (
            <SelectItem value={id} key={id}>
              <SelectItemText>{name}</SelectItemText>

              <Check className="ml-auto size-5 group-data-[state=unchecked]:hidden" />
            </SelectItem>
          ))}
      </SelectContent>
    </Select>
  );
}
